import React, {ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import {
	Annotation,
	AnnotationRectangle as MetadataAnnotationRectangle,
	AnnotationRectangleRectangle, Markup,
	Positions
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class HighlightAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;

		let positions: Array<Positions> = FunctionHelper.applyValue(
			annotation.positions, Annotation.getPositionsDefault()
		);
		let result: Array<ReactNode> = [];

		for (let position of positions) {
			if (!FunctionHelper.exists((position as MetadataAnnotationRectangle).rectangle)) {
				continue;
			}

			let rectBoundaries: AnnotationRectangleRectangle =
				(position as MetadataAnnotationRectangle).rectangle!;

			result.push(
				<AnnotationRectangle {...this.props} popupColor={color} {...rectBoundaries} key={result.length}
									 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
									 popupContent={annotation.contents} popupCreator={annotation.markup?.creator}
									 creationDate={annotation.markup?.creationDate}
									 style={{
										 zIndex: 0
									 }}>
					<svg xmlns={SVG_NAMESPACE}>
						<rect x={0} y={0} width={rectBoundaries.width} height={rectBoundaries.height} style={{
							opacity: opacity / 2,
							fill: color
						}}/>
					</svg>
				</AnnotationRectangle>
			);
		}

		return result;
	}
}